import {
  take,
  put,
  call,
  cancelled,
  select,
  delay,
  fork,
} from 'redux-saga/effects';

import * as popup from '../../ui/popup';
import { PROFILE_PAYMENT_METHODS } from '../../../constants/routes';
import { SUBSCRIBABLE_TYPE } from '../../../constants';
import { handlePostMessage } from './paya-payment-saga';
import { loggedUserIdSelector } from '../../context/selectors';
import { selectPaymentInfoModalProgramId } from '../../programs/selectors';
import { paymentInfoModalActions } from '../../programs/payment-info-modal';
import { actions as accountVaultsActions } from '../../programs/accountVaults';
import { UI_POPUP_TYPES } from '../../../constants/props';

import { handleRefetchPaymentMethods } from '../../payment-methods/sagas/refetch-payment-methods';

import { selectPaymentDelaySeconds } from '../../data/selectors';
import {
  selectAppointmentPaymentInfoModalOpened,
  selectAppointmentPaymentInfoModalProps,
} from '../../appointmentForm/selectors';

const PAYA_POSTBACK_DELAY = 3000;

function* payaAccountFormSagaPaymentTimeout() {
  const delaySeconds = yield select(selectPaymentDelaySeconds);

  yield delay(delaySeconds * 1000);

  yield put(
    popup.actions.show({
      contentType: UI_POPUP_TYPES.MESSAGE,
      contentOptions: {
        message: { id: 'appointment.payment.errorMessage' },
        title: { id: 'payment.accountForm.cardNotPermitted' },
      },
    }),
  );
}

export default function* payaAccountFormSaga() {
  const postMessageChannel = yield call(handlePostMessage);
  const mainUserId = yield select(loggedUserIdSelector);
  const programId = yield select(selectPaymentInfoModalProgramId);

  const isAppointmentPaymentInfoModalOpened = yield select(
    selectAppointmentPaymentInfoModalOpened,
  );

  const modalProps = yield select(selectAppointmentPaymentInfoModalProps);

  const isPatientPaymentMethodsPage = window.location.pathname.includes(
    PROFILE_PAYMENT_METHODS,
  );

  const { userId, locationId } = modalProps || {};

  yield fork(payaAccountFormSagaPaymentTimeout);

  try {
    while (true) {
      const result = yield take(postMessageChannel);
      if (result) {
        yield delay(PAYA_POSTBACK_DELAY); // show response from paya
        yield put(paymentInfoModalActions.clearPayaForm());
        yield delay(PAYA_POSTBACK_DELAY); // waiting for postback from paya to our backend

        if (isAppointmentPaymentInfoModalOpened) {
          yield put(
            accountVaultsActions.send({
              userId,
              subjectId: locationId,
              subjectType: SUBSCRIBABLE_TYPE.LOCATION,
            }),
          );
        } else if (isPatientPaymentMethodsPage) {
          yield call(handleRefetchPaymentMethods);
        } else {
          yield put(
            accountVaultsActions.send({
              userId: mainUserId,
              subjectId: programId,
              subjectType: SUBSCRIBABLE_TYPE.PROGRAM,
            }),
          );
        }

        yield put(popup.actions.hide());
      }
    }
  } finally {
    if (yield cancelled()) {
      postMessageChannel.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/paya-account-form-saga.js